<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="p-card-field">
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Stadium name <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <InputText v-model="name" id="name_id" type="text" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Country <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <div class="p-field p-grid">
              <div class="p-col">
                <input class="input_tmp_validator" id="country_id_va">
                <Dropdown class="p-col-width-a" v-model="country_id" :options="list_country"
                  optionValue="id" optionLabel="name" placeholder="Choose" v-on:change="listProvince()"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">City/ Province <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <div class="p-field p-grid">
              <div class="p-col">
                <input class="input_tmp_validator" id="province_id_va">
                <Dropdown class="p-col-width-a" v-model="province_id" :options="list_province"
                  optionValue="id" optionLabel="name" placeholder="Choose" v-on:change="listDistrict()"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">District <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <div class="p-field p-grid">
              <div class="p-col">
                <input class="input_tmp_validator" id="district_id_va">
                <Dropdown class="p-col-width-a" v-model="district_id" :options="list_district"
                  optionValue="id" optionLabel="name" placeholder="Choose" v-on:change="listWard()"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Ward</label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <div class="p-field p-grid">
              <div class="p-col">
                <input class="input_tmp_validator" id="ward_id_va">
                <Dropdown class="p-col-width-a" v-model="ward_id" :options="list_ward"
                  optionValue="id" optionLabel="name" placeholder="Choose"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Street</label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <InputText v-model="street" id="street_id" type="text" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Latitude <span style="color:red">*</span></label>
          <label class="p-col-fixed in-d">Longtitude <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col-fixed">
            <InputText v-model="latitude" id="latitude_id" type="text" class="" placeholder="Input" />
          </div>
          <div class="p-col-fixed">
            <InputText v-model="longtitude" id="longtitude_id" type="text" class="" placeholder="Input" />
          </div>
        </div>
        <div class="p-field in-d">
          <label>
            <div class="container">
              <input v-if="active==true" type="checkbox" class="cus-checkbox" checked="checked" v-on:change="funtionUpdate($event)">
              <input v-else type="checkbox" class="cus-checkbox" v-on:change="funtionUpdate($event)">
              <span class="checkmark"></span>
              <span>Show</span>
            </div>
          </label>
        </div>   
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
        <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning"
            style="width: 120px !important;"
          />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success"
            style="width: 120px !important;"

          />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success"
            style="width: 120px !important;"
          />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DataServices from '@/core/DataServices'
export default {
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {
      name: '',
      validationErrors: {},
      formMode: this.mode,
      images: [],
      imagesDeletes: [],
      maxFileSize: 1000000, // 1MB
      maxFiles: 10,
      saving:false,
      content : '',
      imgDelete : [],
      list_country:[],
      list_province: [],
      list_district:[],
      list_ward : [],
      country_id : null,
      province_id : null,
      district_id : null,
      ward_id : null,
      street : '',
      active : true,
      latitude : null,
      longtitude : null,
    }
  },
  mounted() {
    this.listCountry();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      console.log("this.model",this.model)
      this.name = this.model.name;
      this.country_id = this.model.country_id;
      if(this.model.country_id){
        this.listProvince();
        this.province_id = this.model.province_id
        if(this.model.province_id){
          this.listDistrict();
          this.district_id = this.model.district_id
          if(this.model.district_id){
            this.listWard();
            this.ward_id = this.model.ward_id
          }
        }
      }
      this.street = this.model.street;
      this.latitude = this.model.latitude;
      this.longtitude = this.model.longtitude;
      this.active = this.model.active;
    }
  },
  methods: {
    async listCountry() {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('country',{"fields" : `id ordinal country_lang(where: {lang: {_eq: "en"}}){lang name}`}),
        variables: {
          where_key: {
            deleted: {'_eq': false},
            active: {'_eq': true}
          },
          orderBy:{ordinal: 'asc'}
        },
        fetchPolicy: "no-cache"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        var tmp = []
        for (let i = 0; i < model.length; i++) {
          const e = model[i];
          tmp.push({
            id : e.id,
            name : e.country_lang[0].name
          })
        }
        this.list_country = tmp;
      }else{
        this.list_country = []
      }
    },
    async listProvince(){
      var country_id = this.country_id
      if(country_id){
        var {data} = await this.$apollo.query({
          query: DataServices.getList('province',{"fields" : `id ordinal province_lang(where: {lang: {_eq: "en"}}){lang name}`}),
          variables: {
            where_key: {
              country_id: {'_eq': country_id},
              deleted: {'_eq': false},
              // active: {'_eq': true}
            },
            orderBy:{ordinal: 'desc'}
          },
          fetchPolicy: "network-only"
        })
        var model = data[Object.keys(data)];
        if (model.length > 0) {
          var tmp = []
          for (let i = 0; i < model.length; i++) {
            const e = model[i];
            tmp.push({
              id : e.id,
              name : e.province_lang[0].name
            })
          }
          this.list_province = tmp;
        }else{
          this.list_province = []
        }
      }else{
        this.list_province = []
      }
    },
    async listDistrict(){
      var province_id = this.province_id
      if(province_id){
        var {data} = await this.$apollo.query({
          query: DataServices.getList('district',{"fields" : `id ordinal district_lang(where: {lang: {_eq: "en"}}){lang name}`}),
          variables: {
            where_key: {
              province_id: {'_eq': province_id},
              deleted: {'_eq': false},
              // active: {'_eq': true}
            },
            orderBy:{ordinal: 'desc'}
          }
        })
        var model = data[Object.keys(data)];
        if (model.length > 0) {
          var tmp = []
          for (let i = 0; i < model.length; i++) {
            const e = model[i];
            tmp.push({
              id : e.id,
              name : e.district_lang[0].name
            })
          }
          this.list_district = tmp;
        }else{
          this.list_district = []
        }
      }else{
        this.list_district = []
      }
    },
    async listWard(){
      var district_id = this.district_id
      if(district_id){
        var {data} = await this.$apollo.query({
          query: DataServices.getList('ward',{"fields" : `id ordinal ward_lang(where: {lang: {_eq: "en"}}){lang name}`}),
          variables: {
            where_key: {
              district_id: {'_eq': district_id},
              deleted: {'_eq': false},
              // active: {'_eq': true}
            },
            orderBy:{ordinal: 'desc'}
          }
        })
        var model = data[Object.keys(data)];
        if (model.length > 0) {
          var tmp = []
          for (let i = 0; i < model.length; i++) {
            const e = model[i];
            tmp.push({
              id : e.id,
              name : e.ward_lang[0].name
            })
          }
          this.list_ward = tmp;
        }else{
          this.list_ward = []
        }
      }else{
        this.list_ward = []
      }
    },
    funtionUpdate(e){
      var check = e.target.checked;
      this.active = check ? check : false
    },
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      let name_id = document.getElementById("name_id");
      if (this.name == undefined || this.name == '' || this.name == null){
        name_id.setCustomValidity("Please enter stadium name.");
      }else{
        name_id.setCustomValidity("");
      }
      let country_id_va = document.getElementById("country_id_va");
      if (this.country_id == undefined || this.country_id == '' || this.country_id == null){
        country_id_va.setCustomValidity("Please choose country.");
      }else{
        country_id_va.setCustomValidity("");
      }
      let province_id_va = document.getElementById("province_id_va");
      if (this.province_id == undefined || this.province_id == '' || this.province_id == null){
        province_id_va.setCustomValidity("Please choose province.");
      }else{
        province_id_va.setCustomValidity("");
      }
      let district_id_va = document.getElementById("district_id_va");
      if (this.district_id == undefined || this.district_id == '' || this.district_id == null){
        district_id_va.setCustomValidity("Please choose district.");
      }else{
        district_id_va.setCustomValidity("");
      }
      
      // let ward_id_va = document.getElementById("ward_id_va");
      // if (this.ward_id == undefined || this.ward_id == '' || this.ward_id == null){
      //   ward_id_va.setCustomValidity("Please choose ward.");
      // }else{
      //   ward_id_va.setCustomValidity("");
      // }

      let latitude_id = document.getElementById("latitude_id");
      if (this.latitude == undefined || this.latitude == '' || this.latitude == null){
        latitude_id.setCustomValidity("Please enter latitude.");
      }else{
        if(isNaN(this.latitude)){
          latitude_id.setCustomValidity("Latitude is not correct.");
        }else{
          latitude_id.setCustomValidity("");
        }
      }
      let longtitude_id = document.getElementById("longtitude_id");
      if (this.longtitude == undefined || this.longtitude == '' || this.longtitude == null){
        longtitude_id.setCustomValidity("Please enter longtitude.");
      }else{
        if(isNaN(this.longtitude)){
          longtitude_id.setCustomValidity("Longtitude is not correct.");
        }else{
          longtitude_id.setCustomValidity("");
        }
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()){
        console.log('test=====================');
        inpObj.reportValidity();
        return true;
      }

    },
  
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return
      }
      var address_google = ''
      if(this.street){
        address_google = this.street
      }
      if(this.ward_id){
        for (let i = 0; i < this.list_ward.length; i++) {
          if(this.list_ward[i].id == this.ward_id){
            if(address_google !==''){
              address_google+= ','+this.list_ward[i].name
            }else{
              address_google = this.list_ward[i].name
            }
            break;
          }
        }
      }
      if(this.district_id){
        for (let i = 0; i < this.list_district.length; i++) {
          if(this.list_district[i].id == this.district_id){
            if(address_google !==''){
              address_google+= ','+this.list_district[i].name
            }else{
              address_google = this.list_district[i].name
            }
            break;
          }
        }
      }
      if(this.province_id){
        for (let i = 0; i < this.list_province.length; i++) {
          if(this.list_province[i].id == this.province_id){
            if(address_google !==''){
              address_google+= ','+this.list_province[i].name
            }else{
              address_google = this.list_province[i].name
            }
            break;
          }
        }
      }
      if(this.country_id){
        for (let i = 0; i < this.list_country.length; i++) {
          if(this.list_country[i].id == this.country_id){
            if(address_google !==''){
              address_google+= ','+this.list_country[i].name
            }else{
              address_google = this.list_country[i].name
            }
            break;
          }
        }
      }
      var params = {
        name: this.name,
        country_id : this.country_id,
        province_id : this.province_id,
        district_id : this.district_id,
        ward_id : this.ward_id,
        active :this.active,
        latitude  :this.latitude,
        longtitude  :this.longtitude,
        street : this.street,
        address_google : address_google
      }
      // console.log("params",params)
      this.$emit('save', params);
      
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
  .p-multiselect {
    width: 450px;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .p-invalid {
    color: red;
    margin: 1px 0px 0px 0px;
  }
  .text-active{
    margin: 0px 0px 0px 8px;
  }
  .p-col-width-a{
    max-width: 600px
  }
  .in-d {
    font-weight: 700;
  }
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
  }
  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #ccc;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: #e95d57;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 8px;
    top: 4px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .container input:checked ~ .checkmark{
    background-color:#E73725 !important; ;
  }
  
  </style>
